import EditTemplateForm from './EditTemplateForm';

export default EditTemplateForm;
